module.exports = __webpack_public_path__ + "img/clinique_ovo.5d4d049e.webp";